import Text from '../../Text'
import { ChatroomMessageActions } from '../ChatroomMessageActions'
import { ChatroomMessageLike } from '../ChatroomMessageLike'

import * as styles from './ChatroomMessageFooter.module.css'

function ChatroomMessageFooter({
  isLiked,
  likeCount,
  message,
  outboundUuid,
  timeLabel,
  onEditMessage,
  onLike,
  onRefetchVisibleMessages,
  onUpdateMessage,
}) {
  return (
    <div className={styles.chatroomMessageFooter}>
      <ChatroomMessageLike
        disabled={!message?.permissions?.can_edit_like}
        isLiked={isLiked}
        likeCount={likeCount}
        onClick={onLike}
      />
      <div className={styles.right}>
        <Text isSecondary>{timeLabel}</Text>
        <ChatroomMessageActions
          message={message}
          outboundUuid={outboundUuid}
          onEditMessage={onEditMessage}
          onRefetchVisibleMessages={onRefetchVisibleMessages}
          onUpdateMessage={onUpdateMessage}
        />
      </div>
    </div>
  )
}

export default ChatroomMessageFooter
